import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ConfigService } from 'src/app/services/json-config.service';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { LoggerService } from './logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private _localAppUrl = '';

  public get localAppUrl(): string {
    const origin = window?.location?.origin;
    if(origin) {
      this._localAppUrl = origin;
    }

    return this._localAppUrl;
  }

  public constructor(
    @Inject(DOCUMENT) private browserDocument: Document,
    private configService: ConfigService,
    private loggerService: LoggerService,
  ) { }

  public goToInvestmentQuestionaireExternalForm(): void {
    this.goToExternalUrl(
      EnvironmentKeys.investmentQuestionaireExternalUrl,
      'Failed to get investment questionaire redirect url, check configuration!'
    );
  }

  public goToAmlFormExternalForm(): void {
    this.goToExternalUrl(
      EnvironmentKeys.amlFormExternalUrl,
      'Failed to get AML form redirect url, check configuration!'
    );
  }

  private goToExternalUrl(key: EnvironmentKeys, errorMsg: string) {
    const externalUrl = this.configService.getConfig(key);
    if (!externalUrl) {
      this.loggerService.error(errorMsg);
      return;
    }

    const redirectUrl = externalUrl + '?redirect_after_complete_uri=' + this.localAppUrl;

    this.browserDocument.location.href = redirectUrl;
  }
}
